var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2497 15.3563C16.2497 16.5069 15.3169 17.4396 14.1663 17.4396C13.0158 17.4396 12.083 16.5069 12.083 15.3563C12.083 14.2057 13.0158 13.2729 14.1663 13.2729C15.3169 13.2729 16.2497 14.2057 16.2497 15.3563Z",
    stroke: "#757575",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 15.3563C7.91667 16.5069 6.98392 17.4396 5.83333 17.4396C4.68274 17.4396 3.75 16.5069 3.75 15.3563C3.75 14.2057 4.68274 13.2729 5.83333 13.2729C6.98392 13.2729 7.91667 14.2057 7.91667 15.3563Z",
    stroke: "#757575",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0837 15.3564H7.91699M16.2503 15.3564H16.8863C17.0696 15.3564 17.1612 15.3564 17.2382 15.3469C17.8061 15.2761 18.2533 14.8289 18.3241 14.261C18.3337 14.184 18.3337 14.0924 18.3337 13.9091V11.6064C18.3337 8.6149 15.9086 6.18978 12.917 6.18978M1.66699 4.10645H10.0003C11.1788 4.10645 11.7681 4.10645 12.1342 4.47256C12.5003 4.83868 12.5003 5.42794 12.5003 6.60645V13.6898M1.66699 11.3981V13.2731C1.66699 14.0519 1.66699 14.4414 1.83446 14.7314C1.94417 14.9214 2.10197 15.0793 2.29199 15.1889C2.58206 15.3564 2.97148 15.3564 3.75033 15.3564",
    stroke: "#757575",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 6.60645H6.66699M1.66699 9.10645H5.00033",
    stroke: "#757575",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetInactive);
export default __webpack_public_path__ + "static/media/fleet-Inactive.eeea9a2d0c7a6a9fb15b287b7f273722.svg";
export { ForwardRef as ReactComponent };